let hiddenSubcategoryIds: number[] = [];
let lockedSubcategoryIds: number[] = [];

export function toggleIn(list: number[], id: number): number[] {
  return list.includes(id) ? list.filter(x => x !== id) : [...list, id];
}

export function isCategoryShown(categoryId: number): boolean {
  return !hiddenSubcategoryIds.includes(categoryId);
}

export function isCategoryLocked(categoryId: number): boolean {
  return lockedSubcategoryIds.includes(categoryId);
}

export function getCategoryOpacity(categoryId: number): number {
  if (!isCategoryShown(categoryId)) return 0;
  if (isCategoryLocked(categoryId)) return 0.5;
  return 1;
}

export function toggleCategoryVisibility(categoryId: number): void {
  hiddenSubcategoryIds = toggleIn(hiddenSubcategoryIds, categoryId);
}

export function toggleCategoryLock(categoryId: number): void {
  lockedSubcategoryIds = toggleIn(lockedSubcategoryIds, categoryId);
}